import React, { useState, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import ThemeToggle from './components/ThemeToggle';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Preloader from './components/Preloader';
import SocialFloat from './components/SocialFloat';
import ScrollReveal from './components/ScrollReveal';
import AdminModal from './components/AdminModal';
import TechBackground from './components/TechBackground';

export default function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [isAdminOpen, setIsAdminOpen] = useState(false);

  useEffect(() => {
    // Secret keyboard shortcut: Ctrl + Shift + A (or Cmd + Shift + A)
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'A' || e.key === 'a')) {
        e.preventDefault();
        setIsAdminOpen((prev) => !prev);
      }
    };

    // Secret URL query or hash check: e.g. #admin or ?admin=true
    if (window.location.hash === '#admin' || window.location.search.includes('admin=true')) {
      setIsAdminOpen(true);
    }

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <div className="font-sans text-white bg-[#1b2d48] scroll-smooth transition-colors duration-500 relative min-h-screen overflow-x-hidden">
      {/* Sci-Fi Split Door Preloader (Opens outwards to reveal page) */}
      <AnimatePresence>
        {isLoading && (
          <Preloader key="cyber-preloader" onLoadingComplete={() => setIsLoading(false)} />
        )}
      </AnimatePresence>

      {/* Main Website Content (Mounted underneath, revealed as doors slide open) */}
      <TechBackground />
      <SocialFloat />
      <ThemeToggle />
      <Navbar />
      
      {/* Sections */}
      <Hero />
      <ScrollReveal><About /></ScrollReveal>
      <ScrollReveal delay={0.05}><Skills /></ScrollReveal>
      <ScrollReveal delay={0.05}><Experience /></ScrollReveal>
      <ScrollReveal delay={0.05}><Projects /></ScrollReveal>
      <ScrollReveal delay={0.05}><Contact /></ScrollReveal>
      <ScrollReveal delay={0.05}><Footer onOpenAdmin={() => setIsAdminOpen(true)} /></ScrollReveal>

      {/* Secret Admin Modal */}
      <AdminModal isOpen={isAdminOpen} onClose={() => setIsAdminOpen(false)} />
    </div>
  );
}


